import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from 'components/Common/Breadcrumb2';
import CreateSolution from './CreateSolution';
import SolutionTable from './SolutionTable';
import { addSolution, getSolutions } from 'store/actions';

const SolutionList = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const solutions = useSelector((state) => state.Solution.solutions);
    const loading = useSelector((state) => state.Solution.loading);
    const error = useSelector((state) => state.Solution.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));

    useEffect(() => {
        dispatch(getSolutions());
    }, [dispatch]);

    const handleSubmit = (data,onClose) => {
        dispatch(addSolution(data,onClose));
    };

    const handleClose = () => setIsOpen(false);

    return (
        <>
            <CreateSolution visible={isOpen} onSubmit={handleSubmit} handleClose={handleClose} />

            <div className='page-content container-fluid'>
                <div className='d-flex justify-content-between align-items-center mx-3'>
                    <Breadcrumb 
                        title="Solutions" 
                        breadcrumbItems={[
                            { title: "Dashboard", link: `/dashboard` }, 
                            { title: "Solutions", link: '#' }
                        ]} 
                    />
                    {permissions?.map(item => item?.permissionName)?.includes("Add Solution") && (
                        <Button 
                            className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center' 
                            onClick={() => setIsOpen(true)}
                        >
                            <i className='ti-plus'></i> Add New
                        </Button>
                    )}
                </div>

                <Row className='ms-2'>
                    <Col className="mb-3" lg={12}>
                        {/* You can add search/filter controls here if needed */}
                    </Col>
                </Row>

                <SolutionTable loading={loading} List={solutions} handleClose={handleClose} isOpen={isOpen} setIsOpen={setIsOpen}/>
            </div>
        </>
    );
};

export default SolutionList;
